import type { UploadFile } from 'antd/lib/upload/interface';
import { notification } from '_atoms';
import { asyncForEach } from 'helpers/helpers';
import { uploadDocument } from 'actions';

type CvUploadItem = string | (UploadFile & { uuid?: string; originFileObj?: File });

const processFile = async (attachedFile: File) => {
  try {
    const formData = new FormData();
    formData.append('file', attachedFile);
    return await uploadDocument(formData);
  } catch {
    notification({ message: `Error while uploading file "${attachedFile.name}".` });
    return null;
  }
};

export const uploadDocs = async (cvs: CvUploadItem[] = []) => {
  const uploadedDocs = cvs.filter((cv): cv is string => typeof cv === 'string');
  let hasFailedUpload = false;
  await asyncForEach(
    cvs.filter((cv): cv is UploadFile & { originFileObj?: File } => typeof cv === 'object').map(d => d.originFileObj),
    async f => {
      if (!f) {
        hasFailedUpload = true;
        return;
      }
      const { uuid } = (await processFile(f)) || {};
      if (uuid) uploadedDocs.push(uuid);
      else hasFailedUpload = true;
    }
  );
  return hasFailedUpload ? null : uploadedDocs;
};
